export default __webpack_public_path__ + "static/media/loc-logo-antes.c83fb528.webp";